import React from 'react'
import { Col, Row } from 'react-bootstrap'
import Date from '../../date/conversational'

const MessageContent = ({
    date,
    content
}) => {

    return (
        <div style={{ backgroundColor: 'white', color: 'rgb(127,127,127)', padding: '15px'}}>
            <Row>
                <Col className='text-muted text-right'><Date date={date} dayName /></Col>
            </Row>
            <Row>
                <Col>
                    {content}
                </Col>
            </Row>
        
        </div>
    )
}

export default MessageContent